import { useEffect, useRef, Fragment, useState } from "react";
import globalClasses from "../../component/commoncomponents/css/Global.module.css";
import classes from "../../component/signin/SignIn.module.css";
import CommonLayout from "../commoncomponents/layout/CommonLayout";
import InputField from "../commoncomponents/input/InputField";
import { emailRegex } from "../commoncomponents/input/Regex";
import { setSnackbar } from "../commoncomponents/alert/SnackbarAction";
import { getRequest, encryptedText, postAxios } from "../../api/AxiosAPICall";
import {
  Link,
  Grid,
  Box,
  Typography,
  Container,
  Avatar,
  CssBaseline,
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import {
  LockOutlined as LockOutlinedIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LoadingButton } from "@mui/lab";
import * as Yup from "yup";
import { Formik, FormikProps } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

const theme = createTheme();
const SignIn = (props: any) => {
  const [isShowPassward, setIsShowPassward] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const location = useLocation();
  const isMounted = useRef<any>();
  let history = useNavigate();
  const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");
  const dataInformation = [
    { id: 1, value: "Name" },
    { id: 2, value: "Address" },
    { id: 3, value: "Date of birth" },
    { id: 4, value: "Gender" },
    {
      id: 5,
      value:
        "Sexuality and other protected characteristics such as religious or other beliefs",
    },
    { id: 6, value: "Ethnicity" },
    { id: 7, value: "Political views" },
    { id: 8, value: "Details of medical conditions" },
    { id: 9, value: "Details of mental health conditions" },
    { id: 10, value: "Details of their behaviors, feelings and actions" },
    {
      id: 11,
      value:
        "Any other details pertaining to their health either directly or indirectly related to the referral such as life history, family tree etc.",
    },
  ];

  const cellmaflexInformation = [
    { id: 1, value: "Manage, report and develop the service" },
    { id: 2, value: "Support financial/ funding decisions" },
    { id: 3, value: "Support medical advances" },
    { id: 4, value: "Act and resolve complaints and incidents" },
    {
      id: 5,
      value:
        "Report events to the appropriate authorities when we are required to do so by law",
    },
  ];
  const personalInformation = [
    {
      id: 1,
      value:
        "Personal identifiers, contacts and characteristics (for example, name and contact details)",
    },
    {
      id: 2,
      value:
        "Demographic details e.g. name, contact details, date of birth, GP details",
    },
    {
      id: 3,
      value:
        "Contact details on next of kin/interested parties in your care e.g. relatives or carers",
    },
    {
      id: 4,
      value:
        "A record of patient visits including medical notes and appointment details",
    },
    {
      id: 5,
      value:
        "Comprehensive medical record storing and collecting information such as: diagnosis, conditions, allergies, tests, investigations, and medications",
    },
  ];
  const shareInformation = [
    { id: 1, value: "Clinicians providing direct care" },
    { id: 2, value: "The patient or parent/carer through the patient portal" },
    {
      id: 3,
      value:
        "Riomed (Cellmaflex) staff only when necessary to assist in providing support for client to resolve technical issues.",
    },
  ];
  const GDPR = [
    {
      id: "a",
      value:
        "Your consent. You can remove your consent at any time by changing the settings.",
    },
    { id: "b", value: "We have a contractual obligation." },
    { id: "c", value: "We have a legal obligation." },
    { id: "d", value: "We have a vital interest." },
    { id: "e", value: "We need it to perform a public task." },
    { id: "f", value: "We have a legitimate interest." },
  ];
  const dataProtection = [
    {
      id: 1,
      text: "Your data protection rights",
      value: "Under data protection law, you have rights including:",
    },
    {
      id: 2,
      text: "Your right of access -",
      value:
        "You have the right to ask us for copies of your personal information.",
    },
    {
      id: 3,
      text: "Your right to rectification -",
      value:
        "You have the right to ask us to rectify personal information you think is inaccurate. You also have the right to ask us to complete information you think is incomplete.",
    },
    {
      id: 4,
      text: "Your right to erasure -",
      value:
        "You have the right to ask us to erase your personal information in certain circumstances.",
    },
    {
      id: 5,
      text: "Your right to restriction of processing -",
      value:
        "You have the right to ask us to restrict the processing of your personal information in certain circumstances.",
    },
    {
      id: 6,
      text: "Your right to object to processing -",
      value:
        "You have the right to object to the processing of your personal information in certain circumstances.",
    },
    {
      id: 7,
      text: "Your right to data portability -",
      value:
        "You have the right to ask that we transfer the personal information you gave us to another organisation, or to you, in certain circumstances.",
    },
  ];
  const icoAddress = [
    { id: 1, value: "The ICO's address:" },
    { id: 2, value: "Information Commissioner's Office" },
    { id: 3, value: "Wycliffe House" },
    { id: 4, value: "Water Lane" },
    { id: 5, value: "Wilmslow" },
    { id: 6, value: "Cheshire" },
    { id: 7, value: "SK9 5AF" },
  ];

  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const dispatch = useDispatch();
  const handleClose = () => {
    setIsOpen(false);
  };

  const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
    setIsOpen(true);
    setScroll(scrollType);
  };

  useEffect(() => {
    isMounted.current = false;
    const singoutHandler = async () => {
      await getRequest("logoutUser", {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      window.location.reload();
    };
    if (jwtToken !== undefined && jwtToken !== "") {
      singoutHandler();
      localStorage.removeItem("token");
    }

    return () => {
      isMounted.current = true;
    };
  }, [location, jwtToken]);

  const authenticate = async (values: any) => {
    console.log("I am here as well");
    const username = !emailRegex.test(values.username) ? values.username : "";
    const email = emailRegex.test(values.username) ? values.username : "";
    const password = encryptedText(values.password);

    console.log(password);

    const response = await postAxios(
      "authenticate",
      {
        username: username,
        password: password,
        email: email,
      },
      {}
    );

    if (response.toString().includes("Incorrect Credentials")) {
      setIsButtonLoading(false);
      if (
        response.toString().split("@")[1] === "NA" ||
        response.toString() === "Incorrect Credentials"
      ) {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            `The Username and Password you entered is incorrect.`,
            "top",
            "center"
          )
        );
      } else if (response.toString().split("@")[1] === "lock") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            `You have reached maximum number of login attempts! Your account has now been locked. Please use the 'Forgot Password' link below`,
            "top",
            "center"
          )
        );
      } else {
        let value =
          "The Username and Password you entered is incorrect and Attempts remaining: " +
          response.toString().split("@")[1];
        dispatch(
          setSnackbar(true, undefined, "warning", value, "top", "center")
        );
      }
    } else if (response.toString() === "ERROR") {
      setIsButtonLoading(false);
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      setIsButtonLoading(false);
      let value = response.toString();
      if (value === "user not found") {
        value = "User Not Found";
      }

      dispatch(setSnackbar(true, undefined, "warning", value, "top", "center"));
    } else if (response.data !== null) {
      isAdminUser(response.data.token);
    }
  };
  const isAdminUser = async (token: any) => {
    const response = await getRequest("checkUserIsAdmin", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.toString() === "ERROR") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else if (response.data !== null) {
      if (response?.data?.isAdmin === "true") {
        localStorage.setItem("token", token);
        localStorage.setItem("show", response.data.isAdmin);

        if (
          response.data.estLicenseExpires !== null &&
          response.data.estLicenseExpires !== undefined
        ) {
          localStorage.setItem(
            "subscriptionDate",
            response.data.estLicenseExpires
          );
        }

        history("/clinician", {
          state: {
            mode: "edit",
            isAdminUser: response.data.isAdmin,
            estApproved: response.data.estApproved,
            isUserHp: response.data.isUserHp,
          },
        });
      } else if (response?.data?.isCellmaflexUser === "true") {
        localStorage.setItem("token", token);
        history("/generateQrCodes");
      } else {
        localStorage.setItem("token", token);
        localStorage.setItem("show", response.data.isAdmin);

        if (
          response.data.estLicenseExpires !== null &&
          response.data.estLicenseExpires !== undefined
        ) {
          localStorage.setItem(
            "subscriptionDate",
            response.data.estLicenseExpires
          );
        }
        history("/clinician", {
          state: {
            mode: "edit",
            isAdminUser: response.data.isAdmin,
            isUserHp: response.data.isUserHp,
          },
        });
      }
    }
  };

  return (
    <Formik
      //********Using Yup for validation********/
      initialValues={{ username: "", password: "" }}
      validationSchema={Yup.object().shape({
        username: Yup.string().required("Username or Email Address Required"),
        password: Yup.string().required("Password Required"),
      })}
      onSubmit={(values: any) => {
        setIsButtonLoading(true);
        console.log("I am here");
        authenticate(values);
      }}
    >
      {(data: FormikProps<any>) => {
        return (
          <Fragment>
            <form onSubmit={data.handleSubmit}>
              <CommonLayout>
                <ThemeProvider theme={theme}>
                  <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                      sx={{
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Avatar sx={{ m: 1, bgcolor: "#1b99d6" }}>
                        <LockOutlinedIcon />
                      </Avatar>
                      <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
                        Sign in to your account
                      </Typography>
                      <Typography
                        component="h6"
                        variant="h6"
                        sx={{ fontSize: "16px" }}
                      >
                        Don't have an account?
                        <Link
                          onClick={() => history("/organization")}
                          sx={{ fontSize: "16px" }}
                        >
                          &nbsp;Register with Cellmaflex
                        </Link>
                      </Typography>
                      <Box sx={{ mt: 1 }} className={globalClasses.boxGrid}>
                        <Stack spacing={2}>
                          <InputField
                            id="username"
                            name="username"
                            label="Username or Email Address"
                            inputvalues={data.values.username}
                            changeevent={data.handleChange}
                            blurevent={data.handleBlur}
                            errormessage={
                              data.touched.username &&
                              Boolean(data.errors.username)
                            }
                            message={
                              data.touched.username && data.errors.username
                            }
                            isrequired={true}
                          />
                          <InputField
                            id="password"
                            name="password"
                            inputvalues={data.values.password}
                            type={isShowPassward ? "text" : "password"}
                            changeevent={data.handleChange}
                            blurevent={data.handleBlur}
                            isrequired={true}
                            onCopy={true}
                            onPaste={true}
                            errormessage={
                              data.touched.password &&
                              Boolean(data.errors.password)
                            }
                            message={
                              data.touched.password && data.errors.password
                            }
                            label="Password"
                            customprops={
                              <IconButton
                                title="password"
                                onClick={() =>
                                  setIsShowPassward(!isShowPassward)
                                }
                              >
                                {isShowPassward ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            }
                          />
                        </Stack>
                        <br />

                        <LoadingButton
                          className={globalClasses.forgotPasswordButton}
                          fullWidth
                          type="submit"
                          size="small"
                          loading={isButtonLoading}
                          variant="contained"
                        >
                          Sign In
                        </LoadingButton>
                        <Grid container>
                          <Grid item xs>
                            <Typography
                              component="h6"
                              variant="h6"
                              sx={{ fontSize: "16px" }}
                            >
                              Forgot your
                              <Link
                                onClick={() => history("/email")}
                                variant="body2"
                                sx={{ fontSize: "16px" }}
                              >
                                &nbsp;Email?
                              </Link>
                              &nbsp;or
                              <Link
                                onClick={() => history("/password")}
                                variant="body2"
                                sx={{ fontSize: "16px" }}
                              >
                                &nbsp;Password?
                              </Link>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                      <Grid container sx={{ mt: "12px", textAlign: "center" }}>
                        <Grid item xs>
                          <Link
                            href="#"
                            variant="body2"
                            sx={{ fontSize: "16px" }}
                            onClick={handleClickOpen("paper")}
                          >
                            Privacy Policy
                          </Link>
                        </Grid>
                      </Grid>
                    </Box>
                    {isOpen && (
                      <Dialog
                        open={isOpen}
                        onClose={handleClose}
                        scroll={scroll}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <DialogTitle className={classes.title}>
                          <Grid container>
                            <Grid item xs={11}>
                              CellmaFlex Privacy Policy
                            </Grid>
                            <Grid item xs={1}>
                              <CancelIcon onClick={handleClose} />
                            </Grid>
                          </Grid>
                        </DialogTitle>

                        <DialogContent
                          sx={{ maxHeight: "350px" }}
                          dividers={scroll === "paper"}
                        >
                          <Typography className={classes.subTitle}>
                            The type of personal information we collect
                          </Typography>
                          <Typography className={classes.information}>
                            We currently collect and process the following
                            information:
                          </Typography>
                          <br />
                          {personalInformation.map(
                            (personalInfo: any, id: any) => (
                              <Typography
                                key={personalInfo.id}
                                className={classes.information}
                              >
                                {personalInfo.id}
                                {"."} {personalInfo.value}
                              </Typography>
                            )
                          )}
                          <br />
                          <Typography className={classes.subTitle}>
                            How we get the personal information and why we have
                            it
                          </Typography>
                          <Typography className={classes.information}>
                            Most of the personal information we process is
                            provided to us directly by you for the following
                            reasons:
                          </Typography>
                          <Typography className={classes.information}>
                            A. To aid the service in providing care and
                            treatment. Some of our other services also collect
                            data via their online referral form. This type of
                            data collected can include:
                          </Typography>
                          {dataInformation.map((listData: any, id: any) => (
                            <Typography
                              key={listData.id}
                              className={classes.information}
                            >
                              {listData.id}
                              {"."} {listData.value}
                            </Typography>
                          ))}
                          <br />
                          <Typography className={classes.information}>
                            The data submitted via the form is emailed securely
                            to the service for processing. No data is stored on
                            Cellmaflex servers.
                          </Typography>
                          <Typography className={classes.information}>
                            We also use online forms that a user can complete to
                            request access to their health records or other
                            records. The data collected on these forms is
                            similar to the data collected via the online
                            referral forms.
                          </Typography>
                          <Typography className={classes.information}>
                            The data submitted via the form is emailed securely
                            to the relevant team for processing. No data is
                            stored on Cellmaflex servers.
                          </Typography>
                          <br />
                          <Typography className={classes.subTitle}>
                            We use the information that is entered in the
                            Cellmaflex portal in order to:
                          </Typography>
                          {cellmaflexInformation.map(
                            (cellmaflexInfo: any, id: any) => (
                              <Typography
                                key={cellmaflexInfo.id}
                                className={classes.information}
                              >
                                {cellmaflexInfo.id}
                                {"."} {cellmaflexInfo.value}
                              </Typography>
                            )
                          )}
                          <br />
                          <Typography className={classes.subTitle}>
                            We may share this information with:
                          </Typography>
                          {shareInformation.map((shareInfo: any, id: any) => (
                            <Typography
                              key={shareInfo.id}
                              className={classes.information}
                            >
                              {shareInfo.id}
                              {"."} {shareInfo.value}
                            </Typography>
                          ))}
                          <br />
                          <Typography className={classes.subTitle}>
                            Under the General Data Protection Regulation (GDPR),
                            the lawful bases we rely on for processing this
                            information are:
                          </Typography>
                          {GDPR.map((GDPRInfo: any, id: any) => (
                            <Typography
                              key={GDPRInfo.id}
                              className={classes.information}
                            >
                              ({GDPRInfo.id}) {GDPRInfo.value}
                            </Typography>
                          ))}
                          <br />
                          <Typography className={classes.subTitle}>
                            How we store your personal information
                          </Typography>
                          <Typography className={classes.information}>
                            All information held within the patient record is
                            encrypted within Cellma and Cellmaflex. We keep your
                            personal and health data for between eight to ten
                            years. We will then dispose your information in line
                            with the Trust's data governance.
                          </Typography>
                          <br />
                          {dataProtection.map(
                            (dataProtectionInfo: any, id: any) => (
                              <Box key={dataProtectionInfo.id}>
                                <Typography className={classes.subTitle}>
                                  {dataProtectionInfo.text}
                                </Typography>
                                <Typography className={classes.information}>
                                  {dataProtectionInfo.value}
                                </Typography>
                                <br />
                              </Box>
                            )
                          )}

                          <Typography className={classes.information}>
                            You are not required to pay any charge for
                            exercising your rights. If you make a request, we
                            have one month to respond to you.
                          </Typography>
                          <Typography className={classes.information}>
                            Please contact us at helplineuk@riomed.com if you
                            wish to make a request.
                          </Typography>
                          <br />
                          <Typography className={classes.subTitle}>
                            How to complain
                          </Typography>

                          <Typography className={classes.information}>
                            If you have any concerns about our use of your
                            personal information, you can make a complaint to us
                            at helplineuk@riomed.com
                          </Typography>
                          <br />
                          <Typography className={classes.information}>
                            Complaints can be forwarded to the ICO if you are
                            unhappy with how we have used your data.
                          </Typography>
                          <br />
                          {icoAddress.map((ICOaddressInfo: any, id: any) => (
                            <Typography
                              key={ICOaddressInfo.id}
                              className={classes.information}
                            >
                              {ICOaddressInfo.value}
                            </Typography>
                          ))}
                          <br />
                          <Typography className={classes.information}>
                            Helpline number: 0303 123 1113
                          </Typography>
                          <Typography className={classes.information}>
                            ICO website:
                            <Link
                              target={"_blank"}
                              href="https://www.ico.org.uk"
                            >
                              https://www.ico.org.uk
                            </Link>
                          </Typography>
                        </DialogContent>
                      </Dialog>
                    )}
                  </Container>
                </ThemeProvider>
              </CommonLayout>
            </form>
          </Fragment>
        );
      }}
    </Formik>
  );
};
export default SignIn;
